module.exports = __webpack_public_path__ + "img/amor-face-0.318ec3fa.jpg";